export default {
  data(){
    return {
      // нужно для хитровыдуманного зума.
      lastScale: 1,

      // множитель зависимости зумирования от колеса скролла
      scrollZoomQuantifier: 0.001
    }
  },
  methods: {
    _listenerPinch(he){
      let newScale = this.lastScale * he.scale;
      this._zoom(newScale);
    },
    _listenerPinchStart(he){
      this._lockFlickityPan();
    },
    _listenerPinchEnd(he){
      if (this._canUserPanSlider()) {
        this._unlockFlickityPan();
      }
      this.lastScale = this._getScale();
    },
    _listenerWhell(e) {
      let delta = e.deltaY > 0 ? 53 : -53;
      let newScale =
        this.lastScale
        + this.lastScale
        // * e.deltaY
        * delta
        * this.scrollZoomQuantifier;

      this._prepapeAndZoom(newScale)
      this._checkSliderLock();
    },
    
    /**
     * зумирует до 1-го и всё такое следовательное.
     * @param he
     * @private
     */
    resetTransform(){
      this._prepapeAndZoom(1);
      this._moveToCenter();
      this._checkSliderLock();
    },
  }
};


// WEBPACK FOOTER //
// ./src/components/slide-main-pinch-listeners.mixin.js